export const environment = {
  production: true,
  activeConsoleLog: true,
  activePWA: true,
  apiEndpoint: 'https://tc-my-api.nt-test.dev/api',
  hubEndpoint: 'https://tc-my-api.nt-test.dev',
  refreshTokenPath: 'account/RefreshToken',
  imagePath: './assets/media/',
  recaptchaSiteKey: '6LcSKc8ZAAAAAADOH_KzpLSjfnF5-j4f1nJA4xqN',
  calcCommissionDebounceTime: 400,
  fileUploadSize: 2097152,
  tablePageSize: 5,
  cardPageSize: 10,
  tablePageSizeOptions: [1, 2, 5, 10, 20],
  allowFileExtentions: ['.jpg', '.jpeg', '.png'],
  notificationRefreshTime: 60000,
  pointPrecision: 2,
  dropdownPageSize: 4,
  dateTimeFormat: 'YYYY/MM/DD HH:mm',
  dateFormat: 'YYYY/MM/DD',
  datePickerConfigFa: {
    // drops: 'down',
    format: 'YYYY/MM/DD',
    showTwentyFourHours: 'enabled',
    showMultipleYearsNavigation: 'enabled',
    locale: 'fa'
  },
  dateTimePickerConfigFa: {
    format: 'HH:mm YYYY/MM/DD',
    showTwentyFourHours: 'enabled',
    showMultipleYearsNavigation: 'enabled',
    locale: 'fa'
  },
  datePickerConfig: {
    // drops: 'down',
    format: 'YYYY/MM/DD',
    showTwentyFourHours: 'enabled',
    showMultipleYearsNavigation: 'enabled',
    locale: 'en'
  },
  dateTimePickerConfig: {
    format: 'YYYY/MM/DD HH:mm',
    showTwentyFourHours: 'enabled',
    showMultipleYearsNavigation: 'enabled',
    locale: 'en'
  },
  tablePageSizeOption: [5, 10, 20, 50],
  forMainServer: true,
  videosDataUrl: {
    videoAnnouncement: {
      url: 'https://tc-static-public.topchnge.net/panel/marketing/banners/TC-Tethe-Dashboard.mp4',
      poster: ''
    },
    deposit: {
      url: 'https://tc-static-public.topchnge.net/panel/marketing/requests/direct-deposit.mp4',
      poster: ''
    },
    withdrawBank: {
      url: 'https://www.aparat.com/v/wlcinjd?refererRef=channel_page',
      poster: 'assets/media/images/dashboard/withdraw-bank.png'
    },
    p2pSell: {
      url: 'https://tc-static-public.topchnge.net/panel/marketing/requests/p2p-sell1.mp4',
      poster: 'assets/media/images/dashboard/p2p_sell1.jpg'
    },
    p2pBuy: {
      url: 'https://tc-static-public.topchnge.net/panel/marketing/requests/p2p-buy1.mp4',
      poster: 'assets/media/images/dashboard/p2p_buy1.jpg'
    },
    affiliate: {
      url: '',
      poster: ''
    },
    depositGenarateCryptoAddress: {
      url: 'https://tc-static-public.topchnge.net/panel/marketing/banners/Deposit-TETHER.mp4',
      poster: ''
    },
    cryptoWithdraw: {
      url: 'https://tc-static-public.topchnge.net/panel/marketing/banners/withdraw-Tether.mp4',
      poster: ''
    },
  },
  featureFlags: {
    transactionsCrypto: true,
    voucherPurchase: false,
    sortAdsP2p: true,
    depositAdsP2pList: true
  },
  activeGoogleRecaptcha: true,
  showInstallBannerPwa: false,
};
